import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useSearch, Link } from '@tanstack/react-router'
import { Loader2, AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'
import { getHomeRoute } from '@/lib/routes'

export default function Callback() {
  const { error: urlError, error_description: urlErrorDescription } = useSearch({ strict: false })
  const { error: auth0Error } = useAuth0()
  const { isAuthenticated, isLoading, profile, authError, loginWithRedirect, logout } = useAuth()

  const isAccessDenied = urlError === 'access_denied'
  const hasBrokenAuthenticatedState = !isLoading && isAuthenticated && !profile

  const error =
    auth0Error ||
    (urlError ? { message: urlErrorDescription || urlError } : null) ||
    (hasBrokenAuthenticatedState
      ? { message: authError || 'We could not finish signing you in. Sign out and try again.' }
      : null)

  if (!error && isAuthenticated && profile) {
    return <Navigate to={getHomeRoute(profile.role)} replace />
  }

  if (error) {
    const shouldLogoutFirst = isAccessDenied || isAuthenticated

    return (
      <div className="min-h-dvh flex items-center justify-center bg-background">
        <div className="max-w-md w-full mx-4 p-6 bg-card rounded-lg border shadow-sm">
          <div className="flex items-center gap-3 text-destructive mb-4">
            <AlertCircle className="w-6 h-6" />
            <h1 className="text-lg font-semibold">Authentication Error</h1>
          </div>
          <p className="text-muted-foreground mb-6">{error.message}</p>
          <div className="flex gap-3">
            <Button variant="outline" asChild>
              <Link to="/" preload="intent">
                Go Home
              </Link>
            </Button>
            <Button onClick={() => (shouldLogoutFirst ? logout() : loginWithRedirect())}>
              {shouldLogoutFirst ? 'Sign Out' : 'Try Again'}
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  )
}
